 setTimeout(function(){
document.querySelectorAll('html')[0].classList.remove('ldd')
}, 500);


var c = 0;
var timerc = setInterval(function(){
  if(document.querySelectorAll('a[href="/checkout"]').length || c > 200) {
    if(document.querySelectorAll('a[href="/checkout"]').length){
      document.querySelectorAll('a[href="/checkout"]')[0].innerHTML = 'Secure Checkout <span class="helloned-divider">|</span> <img class="helloned-secure-icon" src="https://cdn.shopify.com/s/files/1/2560/3528/files/secure-5.png?v=1595216097">';
    }

    clearInterval(timerc);
  }

  c++;
}, 50);

var ic = 0;
var timeric = setInterval(function(){
  if(document.querySelectorAll('.minicart__footer button[data-checkout]').length || ic > 200) {
    if(document.querySelectorAll('.minicart__footer button[data-checkout]').length){
      document.querySelectorAll('.minicart__footer button[data-checkout]')[0].innerHTML = 'Secure Checkout <span class="helloned-divider">|</span> <img class="helloned-secure-icon" src="https://cdn.shopify.com/s/files/1/2560/3528/files/secure-5.png?v=1595216097">';
    }

    clearInterval(timeric);
  }

  ic++;
}, 50);



var ur = window.location.href;
if(ur.includes('/product')){
  var x = 0;
  var timerj = setInterval(function(){
    if (document.querySelectorAll('.jdgm-prev-badge').length && x < 200) {
      var rev = document.querySelectorAll('.jdgm-prev-badge__text')[0].innerHTML;

      rev = rev.replace('review', 'Customer Review');
      rev = "(" + rev + ")";

      if (document.querySelectorAll('.hello-reviews').length == 0 || !document.querySelectorAll('.jdgm-prev-badge__text')[0].innerHTML.includes('Customer')) {
        document.querySelectorAll('.jdgm-prev-badge__text')[0].innerHTML = rev;
      }

      if (!document.querySelectorAll('body')[0].className.includes('hello-reviews') || !document.querySelectorAll('.jdgm-prev-badge__text')[0].innerHTML.includes('Customer')) {
        document.querySelectorAll('body')[0].className += ' hello-reviews';
      }
    }

    if (x > 200 || !document.querySelectorAll('.jdgm-prev-badge').length) {
      clearInterval(timerj);
    }

    x++;
  }, 50);
}


var ur = window.location.href;
if (ur.includes('/collection') && !ur.includes('/product') || ur.includes('/pages/subscribe-save')) {
  var cc = 0;
  var timercc = setInterval(function(){
    if (document.querySelectorAll('.jdgm-prev-badge').length || cc > 100) {
      var revs = document.querySelectorAll('.jdgm-prev-badge__text');
      for (var i = 0; i < revs.length; i++) {
        revs[i].innerHTML = revs[i].innerHTML.replace('reviews', '');

        document.querySelectorAll('.jdgm-prev-badge__text')[i].onclick = function(){
          if(window.innerWidth > 768){
            window.location.href =  (this).parentNode.parentNode.parentNode.getElementsByTagName('a')[0].getAttribute('href');
          }
        };
      }
      if(cc > 100){
        clearInterval(timercc);
      }
    }

    cc++;
  }, 50);
}

/*
if (window.innerWidth < 768) {
  var mn = 0;
  var timermn = setInterval(function() {
    if (document.querySelectorAll('.minicart__items .item .show').length) {
      var cartItems = document.querySelectorAll('.minicart__items .item');
      var subPercent = .15;
      var subSaved = 0;
      for (var i = 0; i < cartItems.length; i++) {
        if (cartItems[i].querySelectorAll('.every-30.show').length || cartItems[i].querySelectorAll('.every-60.show').length) {
          var price = Number(document.querySelectorAll('.minicart__items .item [data-line-price]')[i].innerHTML.substr(1)).toFixed(2);
          var saved = (price/(1-subPercent)) - price;

          subSaved +=  saved;
        }
      }

      document.querySelectorAll('.minicart__freeshipping_success span')[0].innerHTML = "You'll save $"+subSaved.toFixed(2)+" dollars and get FREE SHIPPING when you order today!";
    } else{
      document.querySelectorAll('.minicart__freeshipping_success span')[0].innerHTML = "You've unlocked FREE SHIPPING!";
    }
  }, 100);
}
*/
